import { LitElement, css, html } from "lit";

import { customElement, property } from "lit/decorators.js";

@customElement("wow-link")
export class WowLink extends LitElement {
  static override styles = css`
    :host {
      display: inline;
      cursor: pointer;
    }

    a {
      color: var(--sds-color-text-default-default);
    }
  `;

  @property({ type: String, reflect: true })
  href: string = "#";

  override render() {
    return html`
      <a href=${this.href}>
        <slot></slot>
      </a>
    `;
  }
}
